import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { IClientFetch } from '@/features/clients/models/client-schema'
import type { IEquityStatement } from '@/features/clients/models/equity-statement'
import { INITIAL_DATA_CLIENT_JURIDICAL, INITIAL_DATA_ECONOMIC_JURIDICAL } from '../lib/data-initial'
import type { InfoEconomicJuridical } from '../models/info-economic-juridical'
import type { ApplicantJuridical, ApplicantJuridicalDraft } from '../models/juridical-schema'
import type { LegalRepresentativeJuridical } from '../models/legal-representative-juridical'
import type { VerificationCardJuridical } from '../models/verification-card-juridical-schema'

export interface IPersonJuridicalFetch {
  client: IClientFetch
  applicant: ApplicantJuridical
  legalRepresentatives: LegalRepresentativeJuridical[]
  economicInformation: InfoEconomicJuridical
  verification: VerificationCardJuridical[]
  equityStatement: IEquityStatement | null
}

interface JuridicalState {
  // El store guarda el BORRADOR del formulario (enums pueden estar sin
  // seleccionar); el tipo estricto ApplicantJuridical sólo existe
  // post-validación zod.
  applicant: ApplicantJuridicalDraft
  setApplicant: (applicant: ApplicantJuridicalDraft) => void
  legalRepresentatives: LegalRepresentativeJuridical[]
  setLegalRepresentatives: (legalRepresentative: LegalRepresentativeJuridical[]) => void
  economicForm: InfoEconomicJuridical
  setEconomicForm: (economicForm: InfoEconomicJuridical) => void
  equityStatement: IEquityStatement | null
  setEquityStatement: (equityStatement: IEquityStatement | null) => void
  clearData: () => void
  setAllData: (data: {
    applicant: ApplicantJuridical
    legalRepresentatives: LegalRepresentativeJuridical[]
    economicForm: InfoEconomicJuridical
    equityStatement: IEquityStatement | null
  }) => void
}

export const useJuridicalStore = create<JuridicalState>()(
  persist(
    (set, get) => ({
      applicant: INITIAL_DATA_CLIENT_JURIDICAL,
      setApplicant: (data) => {
        set(() => ({ applicant: { ...data } }))
      },
      legalRepresentatives: [],
      setLegalRepresentatives: (legalRepresentatives) => {
        set(() => ({ legalRepresentatives }))
      },
      economicForm: INITIAL_DATA_ECONOMIC_JURIDICAL,
      setEconomicForm: (economicForm) => {
        set(() => ({ economicForm }))
      },
      equityStatement: null,
      setEquityStatement: (data) => {
        set(() => ({ equityStatement: data ? { ...data } : null }))
      },
      setAllData: (data) => {
        set(() => ({
          applicant: data.applicant,
          legalRepresentatives: data.legalRepresentatives,
          economicForm: data.economicForm,
          equityStatement: data.equityStatement
        }))
      },
      clearData: () => {
        set(() => ({
          applicant: INITIAL_DATA_CLIENT_JURIDICAL,
          legalRepresentatives: [],
          economicForm: INITIAL_DATA_ECONOMIC_JURIDICAL,
          equityStatement: null
        }))
      }
    }),
    {
      name: 'juridical'
    }
  )
)
